import { render } from "./HeaderPractice.vue?vue&type=template&id=09c696cc&scoped=true"
import script from "./HeaderPractice.vue?vue&type=script&lang=js"
export * from "./HeaderPractice.vue?vue&type=script&lang=js"

import "@/css/components/header-practice.css?vue&type=style&index=0&id=09c696cc&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c696cc"]])

export default __exports__